<template>
  <div class="three-less-content">
    <div class="three-less-content__headline" v-text="content.headline" />
    <div class="three-less-content__items">
      <div
        v-for="(item, index) in content.items"
        :key="`three-less-item-${index + 1}`"
        class="three-less-content__item"
        v-show="currentSlide === index"
      >
        <div class="three-less-content__subcopy" v-html="item.subcopy" />
      </div>
    </div>
    <div class="three-less-content__media-items">
      <div
        v-for="(item, index) in content.items"
        :key="`three-less-item-${index + 1}`"
        class="three-less-content__media-item"
      >
        <div class="three-less-content__media">
          <video
            :src="item.videoUrl"
            ref="video"
            muted
            playsinline
            class="three-less-content__video"
            @ended="handleVideoEnd(item)"
          />
          <!-- controls -->
          <img
            v-if="item.isEnded"
            :src="item.coverImageUrl"
            class="three-less-content__cover"
            alt=""
          />
          <button
            v-if="item.isEnded"
            type="button"
            class="three-less-content__replay"
            @click.stop="handleClickReplay(item, index)"
          >
            <img
              src="/theme/rbFront/img/w/magnit/button-replay.png"
              alt="Replay"
            />
          </button>
        </div>
      </div>
    </div>
    <div
      v-for="(item, index) in content.items"
      :key="`three-less-content__sub-item-${index + 1}`"
      class="three-less-content__sub-items"
      v-show="currentSlide === index"
    >
      <div class="three-less-content__bodycopy" v-html="item.bodycopy" />
      <div class="three-less-content__disclimer" v-html="item.disclimer" />
    </div>
  </div>
</template>
<script>
window.$ = window.jQuery
export default {
  name: 'ThreeLessContent',
  props: {
    isViewportActive: {
      type: Boolean,
      required: false,
      default: false,
    },
    content: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {
      currentSlide: 0,
      slick: null,
    }
  },
  watch: {
    isViewportActive: {
      handler(val) {
        // 활성화 된 슬라이드의 비디오 자동재생/일시정지
        if (val) {
          if (!this.content.items[this.currentSlide].isEnded) {
            this.playVideo(this.currentSlide)
          }
        } else {
          this.pauseVideo(this.currentSlide)
        }
      },
    },
  },
  activated() {
    // 최초 탭 활성화 시 자동 플레이
    if (
      this.isViewportActive //&&
      //!this.content.items[this.currentSlide].isEnded
    ) {
      this.restartVideo(this.currentSlide)
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.slick = window.$('.three-less-content__media-items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        infinite: false,
        focusOnSelect: true,
      })

      this.slick.on('afterChange', (event, slick, currentSlide) => {
        this.currentSlide = currentSlide

        // 슬라이드 변경후 현재 슬라이드가 재생 완료되지 않았다면, 자동 재생
        if (!this.content.items[currentSlide].isEnded) {
          this.playVideo(currentSlide)
        }
      })
      this.slick.on('beforeChange', (event, slick, currentSlide) => {
        // 슬라이드 변경전 슬라이드가 재생 완료되지 않았다면, 일시 정지
        if (!this.content.items[currentSlide].isEnded) {
          this.pauseVideo(currentSlide)
        }
      })
    })
  },
  beforeDestroy() {
    this.slick.slick('unslick')
  },
  methods: {
    handleVideoEnd(item) {
      item.isEnded = true
    },
    handleClickReplay(item, index) {
      item.isEnded = false
      this.playVideo(index)
    },
    pauseVideo(index) {
      this.$refs.video[index].pause()
    },
    playVideo(index) {
      this.$refs.video[index].play()
    },
    restartVideo(index) {
      this.$refs.video[index].currentTime = 0
      this.content.items[index].isEnded = false
      this.playVideo(index)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/function.scss';
.three-less-content {
  &__headline {
    font-weight: 600;
    font-size: 32px;
  }
  &__media-items {
    margin-top: 35px;
  }
  &__media-item {
    // margin-left: 100px;
  }
  &__subcopy {
    margin-top: 15px;
    font-size: 24px;
    font-weight: 400;
    color: #000;
  }
  &__media {
    position: relative;
    font-size: 0;
  }
  &__video {
    width: 100%;
  }
  &__cover {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
  &__replay {
    position: absolute;
    bottom: 31px;
    right: 37px;
  }
  &__sub-items {
  }
  &__bodycopy {
    font-size: 24px;
    line-height: 32px;
    font-weight: 400;
    margin-top: 40px;
  }
  &__disclimer {
    font-size: 16px;
    font-weight: 400;
    margin-top: 20px;
  }
  ::v-deep .slick-list {
    //overflow: visible !important;
    // margin-left: -50px;
  }
  ::v-deep .slick-slide {
    // margin-left: 50px;
  }
  ::v-deep .slick-dots {
    margin-top: 20px;
    height: 10px;
  }
  ::v-deep .slick-dots button {
    background-color: #727171;
    border-color: #727171;
    width: 10px;
    height: 10px;
    box-sizing: border-box;
  }
  ::v-deep .slick-arrow {
    width: 18px;
    height: 34px;
  }
  ::v-deep .slick-arrow.slick-prev {
    left: -50px;
    background-image: url(/theme/rbFront/img/w/magnit/pdp_carousel_left.png);
  }
  ::v-deep .slick-arrow.slick-next {
    right: -50px;
    background-image: url(/theme/rbFront/img/w/magnit/pdp_carousel_right.png);
  }
  ::v-deep .slick-dots .slick-active button {
    width: 30px;
    border-radius: 5px;
    background-color: #fd312e;
    border-color: #fd312e;
  }
  @media screen and (max-width: 1080px) {
    padding: 0 calcQuarter(60);
    &__headline {
      font-size: calcQuarter(64);
    }
    &__media-items {
      margin-top: calcQuarter(80);
    }
    &__subcopy {
      font-size: calcQuarter(56);
      line-height: calcQuarter(70);
    }
    &__replay {
      width: calcQuarter(154);
      height: calcQuarter(154);
      right: calcQuarter(37);
      bottom: calcQuarter(39);
      img {
        width: 100%;
      }
    }
    &__bodycopy {
      font-size: calcQuarter(56);
      line-height: calcQuarter(70);
      margin-top: calcQuarter(80);
    }
    &__disclimer {
      font-size: calcQuarter(48);
      line-height: calcQuarter(56);
      margin-top: calcQuarter(70);
      color: #727171;
    }
    ::v-deep .slick-dots {
      margin-top: calcQuarter(60);
      text-align: center;
      height: calcQuarter(24);
    }
    ::v-deep .slick-dots button {
      width: calcQuarter(24);
      height: calcQuarter(24);
    }
    ::v-deep .slick-dots .slick-active button {
      width: calcQuarter(72);
      height: calcQuarter(24);
    }
  }
}
</style>
